export function resolveEntityName(prop: string): string {
  const trimmedProp = prop.trim();

  if (!trimmedProp) return '';
  const [first, ...rest] = Array.from(trimmedProp); // handles surrogate pairs
  return first.toLocaleUpperCase() + rest.join('');
}
